<script>
import BaseContainer from "./BaseContainer.vue";
export default {
  extends: BaseContainer,
  data() {
    return {
      position: "footer",
      allow: ["image", "video", "text", "image-text"]
    };
  }
};
</script>
